import { createRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useSession } from "@/auth/client";
import { SocialDashboard } from "@/components/marketing/social-dashboard";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { BRAND_LABELS, type Brand, type Platform } from "@/lib/marketing/constants";
import { Route as authenticatedRoute } from "../_authenticated";

function MarketingSocialPage() {
  const { brand, platform } = Route.useParams();
  const { data: session } = useSession();
  // biome-ignore lint/suspicious/noExplicitAny: better-auth session role
  const isAdmin = (session?.user as any)?.role === "admin";
  const [syncing, setSyncing] = useState(false);
  const [nonce, setNonce] = useState(0);

  const b = brand as Brand;
  const p = platform as Platform;
  const platformLabel = p.charAt(0).toUpperCase() + p.slice(1);
  const brandLabel = BRAND_LABELS[b] ?? brand;

  const canSync = isAdmin && p === "instagram";
  const handleSync = async () => {
    setSyncing(true);
    try {
      await fetch("/api/marketing-suite/sync/instagram", {
        method: "POST",
        credentials: "include",
      });
      setNonce((n) => n + 1);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title={`${brandLabel} — ${platformLabel}`}
        description="Organic social performance vs. benchmarks. Green = on track, yellow = watch, red = needs attention."
        actions={
          canSync ? (
            <Button variant="outline" size="sm" onClick={handleSync} disabled={syncing}>
              {syncing ? "Syncing…" : "Sync now"}
            </Button>
          ) : undefined
        }
      />
      <SocialDashboard key={`${brand}-${platform}-${nonce}`} brand={b} platform={p} />
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/marketing/social/$brand/$platform",
  component: MarketingSocialPage,
});
